export const SET_TEAMS = 'SET_TEAMS';
export const setTeamsAction = (teams) => ({
  type: SET_TEAMS,
  payload: teams,
});
